import brInvoiceDownloadUrlQuery from "../queries/BrInvoiceDownloadUrl.graphql";
import brTermsOfAdhesionQuery from "../queries/BrTermsOfAdhesion.graphql";
import partnershipAgreementQuery from "../queries/PartnershipAgreement.graphql";
import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import withFullScreen from "./hocs/withFullScreen";
import GlobalFullPageLoader from "./GlobalFullPageLoader";
// import SavingsCalculator from "./SavingsCalculator";
import { constants } from "../global";
import client from "../apollo";
import HomeHeroSection from "./HomeHeroSection";
import { FEATURE_SECTION_EDGE_INSET, FEATURE_SECTION_RADIUS } from "../layout";
import createAsyncComponent from "../utils/createAsyncComponent";

const TermsOfAdhesionSigningDialog = createAsyncComponent(
  () => import("./TermsOfAdhesionSigningDialog"),
  {
    displayName: "AsyncTermsOfAdhesionSigningDialog",
  },
);
const PartnershipAgreementSigningDialog = createAsyncComponent(
  () => import("./PartnershipAgreementSigningDialog"),
  {
    displayName: "AsyncPartnershipAgreementSigningDialog",
  },
);
const HomeDeferredSections = createAsyncComponent(
  () => import("./HomeDeferredSections"),
  {
    displayName: "AsyncHomeDeferredSections",
  },
);





// const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const styles = (theme) => ({});

class Home extends Component {
  invoiceDownloadTriggered = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      contactFormOpen: false, // eslint-disable-line
      signToaDialogOpen: false,
      toaData: null,
      signPartnershipAgreementDialogOpen: false,
      partnershipAgreementData: null,
      pendingInvoiceUrl: null,
      documentLoading: false,
      documentLoadError: false,
      showDeferredSections: false,
    };
  }

  deferredSectionsTimer = null;
  deferredSectionsCleanup = null;

  decodePayload = (str) => {
    try {
      const payload = str.startsWith("data=") ? str.substring(5) : str;
      const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
      const json = atob(base64);
      return JSON.parse(json);
    } catch (err) {
      console.error("Unable to decode data query param", err);
      return null;
    }
  };

  scheduleDeferredSectionLoad = () => {
    const loadDeferredSections = () => {
      this.clearDeferredSectionTimer();
      this.setState({ showDeferredSections: true });
    };

    if (this.state.showDeferredSections) {
      return;
    }

    const interactionEvents = ["pointerdown", "touchstart", "keydown", "click"];
    const onInteraction = () => loadDeferredSections();
    const onScroll = () => {
      if (window.scrollY > 80) {
        loadDeferredSections();
      }
    };

    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, onInteraction, {
        once: true,
        passive: true,
      });
    });
    window.addEventListener("scroll", onScroll, { passive: true });

    this.deferredSectionsCleanup = () => {
      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, onInteraction);
      });
      window.removeEventListener("scroll", onScroll);
      this.deferredSectionsCleanup = null;
    };

    const isMobile =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 767px)").matches;
    this.deferredSectionsTimer = window.setTimeout(
      loadDeferredSections,
      isMobile ? 9000 : 7000,
    );
  };

  clearDeferredSectionTimer = () => {
    if (this.deferredSectionsCleanup) {
      this.deferredSectionsCleanup();
    }
    if (!this.deferredSectionsTimer) {
      return;
    }
    clearTimeout(this.deferredSectionsTimer);
    this.deferredSectionsTimer = null;
  };

  // NOTE: Navigating directly to sections of the home page without the site already
  // loaded was not working because javascript was trying to jump to the section of
  // the home page before the section was rendered. The below is the ChatGPT solution
  // that seems to work. The particular use case here is a link to #faq in the CU
  // welcome email
  waitForEl = (id, attempts = 50, interval = 50) =>
    new Promise((resolve) => {
      const tryFind = (left) => {
        const el = document.getElementById(id);
        if (el) return resolve(el);
        if (left <= 0) return resolve(null);
        setTimeout(() => tryFind(left - 1), interval);
      };
      tryFind(attempts);
    });

  scrollToHash = async () => {
    const raw = window.location.hash;
    if (!raw) return;
    const id = decodeURIComponent(raw.slice(1));
    const el = await this.waitForEl(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  onHashChange = () => this.scrollToHash();

  componentDidMount() {
    if (window.location.hash) {
      this.setState({ showDeferredSections: true }, () => {
        this.scrollToHash();
      });
    } else {
      this.scheduleDeferredSectionLoad();
      this.scrollToHash();
    }
    // 2) handle in-page hash changes
    window.addEventListener("hashchange", this.onHashChange);
  }

  componentWillUnmount() {
    this.clearDeferredSectionTimer();
    window.removeEventListener("hashchange", this.onHashChange);
  }
  // End of ChatGPT solution

  setDocumentLoading = (loading) => {
    if (this.state.documentLoading !== loading) {
      this.setState({ documentLoading: loading });
    }
  };

  handleDownloadInvoice(brInvoiceId, offlineDownloadKey) {
    if (this.invoiceDownloadTriggered) {
      return;
    }

    this.invoiceDownloadTriggered = true;
    this.setDocumentLoading(true);
    client
      .query({
        query: brInvoiceDownloadUrlQuery,
        variables: {
          input: {
            brInvoiceId: parseInt(brInvoiceId, 10),
            includeStatement: true,
            offlineDownloadKey,
            viewInline: true,
          },
        },
        fetchPolicy: "no-cache",
      })
      .then(
        (resp) => {
          if (resp.loading) {
            return null;
          }
          if (resp.error) {
            this.invoiceDownloadTriggered = false;
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true });
            return null;
          }
          if (!resp.data?.brInvoiceDownloadUrl) {
            this.invoiceDownloadTriggered = false;
            this.setDocumentLoading(false);
            return null;
          }

          // Navigate directly to the S3 URL to display PDF inline
          // The S3 URL is configured with Content-Disposition: inline
          window.location.href = resp.data.brInvoiceDownloadUrl;
          this.setDocumentLoading(false);
          return null;
        },
        (err) => {
          this.invoiceDownloadTriggered = false;
          this.setDocumentLoading(false);
          this.setState({ documentLoadError: true });
          console.error(err);
        },
      );
  }

  handleTermsOfAdhesionSigning(brTermsOfAdhesionId, secretKey) {
    if (this.state.documentLoading) {
      return;
    }
    this.setDocumentLoading(true);
    client
      .query({
        query: brTermsOfAdhesionQuery,
        variables: {
          input: {
            id: parseInt(brTermsOfAdhesionId, 10),
            secretKey,
          },
        },
        fetchPolicy: "no-cache",
      })
      .then(
        (resp) => {
          if (resp.loading) {
            return null;
          }
          if (resp.error) {
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true });
            return null;
          }
          if (!resp.data?.brTermsOfAdhesion) {
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true });
            return null;
          }
          if (!resp.data.brTermsOfAdhesion.pendingSignatureViewUrl) {
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true }); // Not necessarily an error as it may just already be signed but want to prevent further processing
            return null;
          }
          this.setState({
            toaData: resp.data.brTermsOfAdhesion,
            signToaDialogOpen: true,
          });
          this.setDocumentLoading(false);
        },
        (err) => {
          this.setDocumentLoading(false);
          this.setState({ documentLoadError: true });
          console.error(err);
        },
      );
  }

  handlePartnershipAgreementSigning(salesPartnerId, secretKey) {
    if (this.state.documentLoading) {
      return;
    }
    this.setDocumentLoading(true);
    client
      .query({
        query: partnershipAgreementQuery,
        variables: {
          input: {
            id: parseInt(salesPartnerId, 10),
            secretKey,
          },
        },
        fetchPolicy: "no-cache",
      })
      .then(
        (resp) => {
          if (resp.loading) {
            return null;
          }
          if (resp.error) {
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true });
            return null;
          }
          if (!resp.data?.brSalesPerson) {
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true });
            return null;
          }
          if (!resp.data.brSalesPerson.pendingAgreementDownloadUrl) {
            this.setDocumentLoading(false);
            this.setState({ documentLoadError: true }); // Not necessarily an error as it may just already be signed but want to prevent further processing
            return null;
          }
          this.setState({
            partnershipAgreementData: resp.data.brSalesPerson,
            signPartnershipAgreementDialogOpen: true,
          });
          this.setDocumentLoading(false);
        },
        (err) => {
          this.setDocumentLoading(false);
          this.setState({ documentLoadError: true });
          console.error(err);
        },
      );
  }

  renderAboveTheFold() {
    const { setSavingsCalculatorOpen } = this.props;

    return (
      <HomeHeroSection
        title={
          <>
            Descubra o jeito novo de ter sua conta de luz até{" "}
            <span
              style={{
                color: "#95E362",
                whiteSpace: "nowrap",
                display: "inline-block",
                textShadow: "rgba(1,54,46,0.35) 0 0 10px",
              }}
            >
              {constants.discountRate * 100}%
              <span
                style={{
                  position: "relative",
                  top: "-0.4em",
                  fontSize: "0.6em",
                }}
              >
                *
              </span>
            </span>{" "}
            mais barata TODO MÊS.
          </>
        }
        ctaLabel="Simular Economia"
        ctaButtonProps={{
          onClick: () => setSavingsCalculatorOpen(true),
        }}
      />
    );
  }

  renderDeferredSectionPlaceholders() {
    const { fullScreen } = this.props;

    const sectionShells = [
      {
        key: "testimonials",
        minHeight: fullScreen ? 620 : 760,
        style: {
          width: "100%",
          margin: `${FEATURE_SECTION_EDGE_INSET} 0`,
          background: "#f4f4f6",
        },
      },
      {
        key: "clients",
        minHeight: fullScreen ? 180 : 220,
        style: {
          width: "100%",
          background: "#f4f4f6",
        },
      },
      {
        key: "projects",
        minHeight: 760,
        style: {
          width: `calc(100% - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
          margin: `${fullScreen ? "1rem" : "4rem"} ${FEATURE_SECTION_EDGE_INSET} ${FEATURE_SECTION_EDGE_INSET}`,
          borderRadius: `${FEATURE_SECTION_RADIUS}px`,
          background:
            "linear-gradient(100deg, rgba(14,15,12,0.78) 5%, rgba(14,15,12,0.52) 44%, rgba(14,15,12,0.26) 100%)",
        },
      },
      {
        key: "how-it-works-steps",
        minHeight: fullScreen ? 1040 : 860,
        style: {
          width: "100%",
          margin: `${FEATURE_SECTION_EDGE_INSET} 0 0`,
          background: "#f4f4f6",
        },
      },
      {
        key: "how-it-works-advantages",
        minHeight: fullScreen ? 1040 : 720,
        style: {
          width: `calc(100% - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
          margin: `${FEATURE_SECTION_EDGE_INSET} ${FEATURE_SECTION_EDGE_INSET}`,
          borderRadius: `${FEATURE_SECTION_RADIUS}px`,
          background:
            "linear-gradient(130deg, #01362E 0%, #03594C 54%, #95E362 100%)",
        },
      },
      {
        key: "who-we-are",
        minHeight: fullScreen ? 980 : 760,
        style: {
          width: "100%",
          margin: `${FEATURE_SECTION_EDGE_INSET} 0`,
          background: "#f4f4f6",
        },
      },
      {
        key: "faq",
        minHeight: fullScreen ? 1240 : 980,
        style: {
          width: `calc(100% - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
          margin: `0 ${FEATURE_SECTION_EDGE_INSET} ${FEATURE_SECTION_EDGE_INSET}`,
          borderRadius: `${FEATURE_SECTION_RADIUS}px`,
          background:
            "linear-gradient(140deg, #01362E 0%, #02483D 62%, #056D5C 100%)",
        },
      },
    ];

    return (
      <>
        {sectionShells.map((section) => (
          <div
            key={`deferred-shell-${section.key}`}
            aria-hidden="true"
            style={{
              minHeight: `${section.minHeight}px`,
              position: "relative",
              overflow: "hidden",
              ...section.style,
            }}
          />
        ))}
      </>
    );
  }

  render() {
    const {
      toaData,
      signToaDialogOpen,
      partnershipAgreementData,
      signPartnershipAgreementDialogOpen,
      documentLoading,
      documentLoadError,
      showDeferredSections,
    } = this.state;
    const { fullScreen } = this.props;
    const searchParams = new URLSearchParams(window.location.search);
    const data = searchParams.get("data");
    const download = searchParams.get("download");
    const fatura = searchParams.get("fatura");
    const key = searchParams.get("key");
    const signtoa = searchParams.get("signtoa");
    const toaid = searchParams.get("toaid");
    const signpa = searchParams.get("signpa");
    const spid = searchParams.get("spid");
    let secretKey = null;
    if (data) {
      const dataObj = this.decodePayload(data);
      secretKey = dataObj && dataObj.key;
      if (
        dataObj &&
        dataObj.type === "viewfatura" &&
        dataObj.id &&
        dataObj.key &&
        !documentLoadError &&
        !documentLoading &&
        !this.invoiceDownloadTriggered
      ) {
        this.handleDownloadInvoice(dataObj.id, dataObj.key);
      } else if (
        dataObj &&
        dataObj.type === "signtoa" &&
        dataObj.id &&
        dataObj.key &&
        !toaData &&
        !documentLoadError &&
        !documentLoading
      ) {
        this.handleTermsOfAdhesionSigning(dataObj.id, dataObj.key);
      } else if (
        dataObj &&
        dataObj.type === "signpa" &&
        dataObj.id &&
        dataObj.key &&
        !partnershipAgreementData &&
        !documentLoadError &&
        !documentLoading
      ) {
        this.handlePartnershipAgreementSigning(dataObj.id, dataObj.key);
      }
    } else if (
      download &&
      fatura &&
      key &&
      !documentLoadError &&
      !documentLoading &&
      !this.invoiceDownloadTriggered
    ) {
      this.handleDownloadInvoice(fatura, key);
    } else if (
      signtoa &&
      toaid &&
      key &&
      !toaData &&
      !documentLoadError &&
      !documentLoading
    ) {
      this.handleTermsOfAdhesionSigning(toaid, key);
    } else if (
      signpa &&
      spid &&
      key &&
      !partnershipAgreementData &&
      !documentLoadError &&
      !documentLoading
    ) {
      this.handlePartnershipAgreementSigning(spid, key);
    }
    if (!secretKey) {
      secretKey = key;
    }

    return (
      <>
        {signToaDialogOpen && toaData?.pendingSignatureViewUrl && (
          <TermsOfAdhesionSigningDialog
            open={true}
            pdfUrl={toaData.pendingSignatureViewUrl}
            downloadUrl={toaData.pendingSignatureDownloadUrl}
            brPowerPlan={toaData.brPowerPlan}
            brConsumerUnit={toaData.brConsumerUnit}
            signersName={
              toaData.brConsumerUnit?.brCustomer?.primaryBrContact?.fullName
            }
            termsOfAdhesionId={toaData.id}
            secretKey={secretKey}
            loadingFallback={
              <GlobalFullPageLoader
                id="home-toa-dialog-loading"
                message="Carregando documento..."
              />
            }
          />
        )}
        {signPartnershipAgreementDialogOpen && partnershipAgreementData && (
          <PartnershipAgreementSigningDialog
            open={true}
            pdfUrl={partnershipAgreementData.pendingAgreementDownloadUrl}
            signersName={partnershipAgreementData.adminBrContact.fullName}
            salesPartnerId={partnershipAgreementData.id}
            secretKey={secretKey}
            loadingFallback={
              <GlobalFullPageLoader
                id="home-partnership-dialog-loading"
                message="Carregando documento..."
              />
            }
          />
        )}
        {documentLoading ? (
          <GlobalFullPageLoader
            id="home-document-loading"
            message="Carregando documento..."
          />
        ) : null}
        {this.renderAboveTheFold()}
        {showDeferredSections ? (
          <HomeDeferredSections
            fullScreen={fullScreen}
            loadingFallback={this.renderDeferredSectionPlaceholders()}
          />
        ) : this.renderDeferredSectionPlaceholders()}
        {/* TODO: Uncomment and make the blog */}
        {/* <Grid
          container
          style={{
            padding: "1rem",
            position: "relative",
            background: theme.palette.white.main,
            // background: theme.palette.primary.main,
          }}
          justifyContent="center"
        >
          <Grid item xl={8} lg={9} xs={12}>
            <Typography
              style={{ marginTop: "2rem", width: "100%" }}
              gutterBottom
              color="primary"
              variant="h2"
            >
              Fique por dentro
            </Typography>
          </Grid>
          <Grid
            style={{ position: "relative" }}
            item
            xl={8}
            lg={9}
            md={10}
            xs={12}
          >
            {loading ? (
              <Grid
                container
                alignItems="center"
                style={{ position: "relative" }}
              >
                <Grid
                  style={{
                    width: "100%",
                    position: "absolute",
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  <CircularProgress
                    style={{ color: theme.palette.white.main }}
                  />
                </Grid>
              </Grid>
            ) : null}
            <iframe
              title="Energea Instagram Feed"
              src="https://www.powr.io/social-feed/u/9d841a9c_1597964052#platform=iframe"
              style={{ width: "100%" }}
              height="420px"
              onLoad={() => this.setState({ loading: false })}
              frameBorder="0"
            ></iframe>
          </Grid>
        </Grid> */}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withFullScreen(Home, { breakpoint: "sm" }),
);
